import React from "react";
import { Link } from "react-router-dom";

function Error(){
    return(
<div
      style={{
        textAlign: "center",
        padding: "100px 20px",
        color: "#333",
      }}
        >
            <img
                      src="assets/images/error/404.png"
                      alt="404"
                      style={{  }}
                    />
      <h2 style={{ marginBottom: "20px" }}>Page Not Found</h2>
      <p style={{ marginBottom: "30px" }}>
        Sorry, the page you’re looking for doesn’t exist or has been moved.
      </p>
      <Link
        to="/"
        style={{width: "10%" }} className="tmp-btn btn-primary button-custom mb-5 d-block m-auto"
      >
        Go Back Home
      </Link>
        </div>
        
            )
}


export default Error